import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";
import { LANGUAGES, setLanguage } from "../../i18n";
import "./languageSwitcher.scss";

// Selector de idioma para el header. Disponible para todos los roles.
export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  return (
    <div className="lang-switcher" ref={ref}>
      <button
        type="button"
        className="lang-switcher__btn"
        onClick={() => setOpen((o) => !o)}
        title={t("Idioma")}
        aria-label={t("Idioma")}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <Globe size={20} aria-hidden="true" />
        <span className="lang-switcher__code">{current.code.toUpperCase()}</span>
      </button>

      {open && (
        <ul className="lang-switcher__menu" role="listbox" aria-label={t("Idioma")}>
          {LANGUAGES.map((l) => {
            const active = l.code === current.code;
            return (
              <li key={l.code}>
                <button
                  type="button"
                  role="option"
                  aria-selected={active}
                  className={`lang-switcher__option${active ? " active" : ""}`}
                  onClick={() => {
                    setLanguage(l.code);
                    setOpen(false);
                  }}
                >
                  <span>{l.label}</span>
                  {active && <Check size={16} aria-hidden="true" />}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
